import axios from 'axios';
import { createDeferralQuery } from './queries';

const addDeferral = (model) =>
    new Promise((resolve, reject) => {
        const query = createDeferralQuery({ model });
        const request = axios.post(query.url, { ...query.body });

        request
            .then((response) => {
                resolve({ data: response.data });
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error('Unable to add Deferral'));
            });
    });

export default addDeferral;
